export default {
    'Loading...': 'Ladataan...',
    'Booking an appointment': 'Nimittäminen',
    'Online registration is disabled': 'Online-varaukset pois käytöstä',
    'Select service': 'Valitse palvelu',
    'Confirm': 'Vahvistaa',
    'Enter the phone number provided by registering at the clinic': 'Syötä puhelinnumero, jonka määritit rekisteröityessäsi klinikalle',
    'Enter Phone Number': 'Anna puhelinnumero',
    'Send': 'Lähettää',
    'Verification Code': 'Vahvistuskoodi',
    'verification-message': 'Vahvistuskoodin sisältävä viesti on lähetetty numeroon {phone}. Syötä koodi jatkaaksesi.',
    'Invalid code': 'Virheellinen koodi',
    'Wrong Number?': 'Väärä numero?',
    'Verifying...': 'Tutkimus...',
    'Verify': 'Vahvistaa',
    'Name': 'Nimi',
    'Enter Name': 'Kirjoita nimesi',
    'Surname': 'Sukunimi',
    'Enter Surname': 'Kirjoita sukunimi',
    'Saving...': 'Säilytys...',
    'Save': 'Tallentaa',
    'We will contact you shortly and confirm the appointment.': 'Otamme sinuun yhteyttä pian ja vahvistamme varauksesi.',
    'No free time available': 'Ei vapaa-aikaa tänä päivänä',
    'Back to Home': 'Takaisin kotiin',
    'No upcoming appointments': 'Ei tulevia tapaamisia',
    'Select clinic': 'Valitse klinikka',
    'You are registered in these clinics': 'Olet rekisteröitynyt seuraaville klinikoille',
    'No clinics': 'Ei klinikoita',
    'Home': 'Aloitusnäyttö',
    'Appointments': 'Tapaamiset',
    'Contacts': 'Yhteystiedot',
    'Switch clinic': 'Vaihda klinikka',
    'Logout': 'Kirjautua ulos',
    'Log in to your personal cabinet': 'Kirjaudu sisään henkilökohtaiselle tilillesi',
    'Log In': 'Kirjaudu sisään',
    'Book an appointment': 'Varata tapaaminen',
    'Upcoming appointments': 'Tulevia tapaamisia',
    'Show all': 'Näytä kaikki',
    'Not confirmed': 'Ei vahvistettu',
    'Confirmed': 'Vahvistettu',
    'Cancelled': 'Peruutettu',
    'Completed': 'Valmis',
    'Not shown': 'Ei näytetty',
    'Started': 'Aloitettu',

    'Please, enter valid phone number': 'Ole hyvä ja anna kelvollinen puhelinnumero',
    'Enter code from SMS': 'Syötä koodi tekstiviestistä',

    'Select a specialist': 'Valitse asiantuntija',
    'No specialists available': 'Ei erikoisasiantuntijoita saatavilla',
    'Select a day': 'Valitse päivä',
    'Select a time': 'Valitse aika',
    'Input data to register': 'Syötä tiedot rekisteröintiä varten',
    'Enter your name': 'Kirjoita nimesi',
    'Enter your phone number': 'Anna puhelinnumerosi',
    'Phone number': 'Puhelinnumero',

    'Clinic not found': 'Klinikkaa ei löytynyt',
    'Check the link or contact the clinic': 'Tarkista linkki tai ota yhteyttä klinikkaan',
    'Please call the clinic to book an appointment': 'Soita klinikalle varataksesi ajan',
    'About the clinic': 'Tietoa klinikasta',
    'Open now': 'Avoinna',
    'Closed now': 'Suljettu',
    'Closed': 'Suljettu',
    'Change': 'Muuta',
    'Back': 'Takaisin',
    'Step {current} of {total}': 'Vaihe {current} / {total}',
    'Select date and time': 'Valitse päivä ja aika',
    'Your phone number': 'Puhelinnumerosi',
    'Check the details': 'Tarkista tiedot',
    'Appointment booked': 'Aika varattu',
    'No services available': 'Ei palveluita saatavilla',
    'Try another service or call the clinic': 'Kokeile toista palvelua tai soita klinikalle',
    'Week': 'Viikko',
    'Month': 'Kuukausi',
    'Pick another day in the calendar above': 'Valitse toinen päivä yllä olevasta kalenterista',
    'Morning': 'Aamu',
    'Afternoon': 'Päivä',
    'Evening': 'Ilta',
    'We will send a confirmation code to this number': 'Lähetämme vahvistuskoodin tähän numeroon',
    'Your details are used only for this appointment': 'Tietojasi käytetään vain tähän ajanvaraukseen',
    'Verification failed, try again!': 'Vahvistus epäonnistui, yritä uudelleen',
    'Resend code': 'Lähetä koodi uudelleen',
    'Resend in {seconds} s': 'Lähetä uudelleen {seconds} s kuluttua',
    'Specialist': 'Asiantuntija',
    'Service': 'Palvelu',
    'Address': 'Osoite',
    'Clinic phone': 'Klinikan puhelin',
    'Could not book the appointment, please try again': 'Ajanvaraus epäonnistui, yritä uudelleen',
    'We will contact you shortly to confirm the appointment': 'Otamme sinuun pian yhteyttä ja vahvistamme ajan',
    'Website': 'Verkkosivu',
    'Email': 'Sähköposti',
    'Opening hours': 'Aukioloajat',
    'Today': 'Tänään',
    'Tomorrow': 'Huomenna',
    'Nearest available time': 'Lähin vapaa aika',
    'All specialists': 'Kaikki asiantuntijat',
    'No free time in the next days': 'Ei vapaita aikoja lähipäivinä',
    'Search by name': 'Haku nimellä',
    'Nobody found': 'Ei osumia',
    'Choose another service': 'Valitse toinen palvelu',
    'Could not load the time': 'Aikoja ei saatu ladattua',
    'Check the connection and try again': 'Tarkista yhteys ja yritä uudelleen',
    'Try again': 'Yritä uudelleen',
    'Thank you for the reservation': 'Kiitos varauksesta',
    'Go to your cabinet': 'Siirry omalle tilille',
}
